var header = {
  pro: "Young Platform Pro",
  base: "Young Platform",
  step: "Young Platform Step",
  login: "Log in",
  login_text: "Already have an account?",
  signup: "Sign up",
  signup_text: "Don't have an account yet?",
  access: "Enter",
  start: "Getting started",
  menu: {
    dashboard: "Home",
    giftcard: "Gift card",
    markets: "Markets",
    wallet: "Wallet",
    settings: "Account",
    help: "Support",
    logout: "Log Out",
    info: "Info"
  }
};
var copyright = "Young Platform S.p.a. All rights reserved.";
var view_more = {
  btn: "Mostra di più"
};
var textfield = {
  password_minimum_length: "At least 8 characters, numbers, lower and upper letters",
  password_weak: "Password strenght: *color*weak*color*",
  password_improved: "Password strenght: *color*improved*color*",
  password_strong: "Password strenght: *color*strong*color*"
};
var En = {
  header: header,
  copyright: copyright,
  "join-community": {
    title: "Join our *color*community*color*",
    newsletter_title: "*color*Get*color* all the updates",
    newsletter_caption: "Receive market news and updates on partnerships and new coin listings.",
    newsletter_placeholder: "Enter your email",
    newsletter_button: "Subscribe",
    newsletter_registered: "Thank you!",
    telegram_title: "Join our *color*Telegram*color* channel",
    telegram_caption: "Take part in discussions on our channels, chat with the team and discover features in advance.",
    telegram_button: "Join"
  },
  "landing-footer": {
    product: "Product",
    company: "Company",
    support: "Support",
    about: "About",
    learn: "Learn",
    learn1: "Buy Bitcoin in 5 Steps",
    learn2: "Bitcoin: Guide for Beginners",
    learn3: "Earn Basic Attention Token (BAT)",
    buy1: "How to buy Bitcoin",
    buy2: "How to buy Ethereum",
    buy3: "How to buy Polkadot",
    download: "Download app",
    service_center: "Support",
    glossary: "Glossary",
    faq_1: "Taxation",
    faq_2: "Exchange",
    faq_3: "Commissions",
    careers: "Careers",
    whyUs: "Why Young Platform",
    ambassador: "Become an Ambassador",
    pressKit: "Press Kit",
    blog: "Blog",
    conditions: "Conditions",
    events: "Events",
    language: "Language",
    it: "Italian",
    en: "English",
    newsletter: "Newsletter",
    talking: "Talking About Us",
    footer_terms: "Terms and conditions",
    footer_terms_step: "Terms and conditions - Step",
    refund_policy: "Refund policy",
    select_lang: "Change language",
    commission_price: "Commissions & Price",
    sub_copyright: "Young Platform S.p.a. Via Francesco Cigna 96/17, 10155, Torino, Italia P. Iva 11931440017",
    contact_us: "Contact us",
    "talking-about-us": "Talking about us"
  },
  view_more: view_more,
  textfield: textfield
};
export { copyright, En as default, header, textfield, view_more };